import { formatAsMoney, formatWithCommas } from '@perch-labs/warbler';
import { copyFor } from 'config';

const getCopy = copyFor('utils');

export const kwhToMwh = (expectedKwh: number) =>
  formatWithCommas(expectedKwh / 1000, 0);

// TODO - remove in favor of default i18n-js pluralization
export const monthString = (month: number) =>
  month < 2 ? `${getCopy('month')}` : `${month} ${getCopy('months')}`;

// TODO move to warbler
export const roundWithCommas = (num: number) =>
  num < 0.5 ? formatWithCommas(num, 2) : formatWithCommas(num, 0);

export const getJoiner = (index: number, length: number) => {
  const joiners = getCopy('listJoiners');
  if (index + 1 === length) return joiners[0];
  if (index + 2 === length) return length > 2 ? joiners[3] : joiners[1];
  return joiners[2];
};

// TODO: move to warbler
export const getTimeOfDay = () => {
  let timeOfDay;
  const currentHour = new Date().getHours();

  if (currentHour < 12) timeOfDay = 'morning';
  else if (currentHour < 18) timeOfDay = 'afternoon';
  else timeOfDay = 'evening';

  return timeOfDay;
};

export const getSolarProjectName = (name: string) => {
  if (name.slice(-5) === 'Solar') return `${name} Farm`;
  return `${name} Solar Farm`;
};

// Returns a fully qualified URL for a given path
// TODO move to warbler
export const getFullUrl = (path: string): string => {
  const host = window.location.hostname;
  const port = window.location.port;
  let baseUrl = `${window.location.protocol}//${host}`;
  if (port) baseUrl += `:${port}`;
  return `${baseUrl}${path}`;
};

// 100 > $1.00
export const money = (cents: number): string =>
  formatAsMoney(cents, { conversion: 'fromCents' }) || '';

export const fetchPlanName = (planNickname: string, planId: number) => {
  if (planNickname.includes(planId.toString())) return `Plan ID#${planId}`;
  else return `the plan ${planNickname}`;
};
